import Sticky from 'sticky-js';

function init () {
  let sticky = new Sticky('.sticky');
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/js/vanilla/social-links.js